/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Appointment/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import AppointmentCard from 'DesignSystem/AppointmentCard/index'
import AppointmentType from './AppointmentType/index'
import React from 'react'
import Time from './Time/index'
import Tysiav2IconEditFilled from 'DesignSystem/Svgs/Tysiav2IconEditFilled/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Appointment({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/NextAppointment/Content/Content/Content/Appointment"
  
}) {
let upcomingAppointmentAppointmentTypeDisplayColorIdValueData = fromData.useDataFormat({ viewPath,
context: 'upcoming_appointment',
path: 'appointment.type.display_color_id',
format: fromFormat.appointmentTypeColor,
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
  return (<React.Fragment
>
<div
  data-testid="Appointment.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<AppointmentCard
  viewPath={`${viewPath}/AppointmentCard`}
 paddingTop={dtSpaceXxs}
 paddingBottom={dtSpaceXxs}
 paddingLeft={dtSpaceXs}
 paddingRight={dtSpaceXs}
 width="auto"
 minHeight={24}
 cursor="pointer"
 data="upcoming_appointment.appointment.type.display_color_id"
 format="/Data/format.js appointmentTypeColor"
 appointmentColor={upcomingAppointmentAppointmentTypeDisplayColorIdValueData}
>
{childProps => (
<div
  data-testid="Appointment.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-dUIJ5': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs}}
 className={`views-block ${styles.Horizontal}`}
>
<AppointmentType
  viewPath={`${viewPath}/AppointmentType`}
/>
<Time
  viewPath={`${viewPath}/Time`}
/>
<Tysiav2IconEditFilled
  viewPath={`${viewPath}/Tysiav2IconEditFilled`}
/>
</div>
)}
</AppointmentCard>
</div>
{children}
</React.Fragment>)
}